import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  $createTextNode,
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  type LexicalCommand,
} from "lexical";
import { useEffect } from "react";

/**
 * Inserts plain text at the current cursor / selection. Used by the
 * built-in emoji button and any extension that needs to drop a string
 * into the editor without a custom node.
 */
export const INSERT_TEXT_AT_CURSOR_COMMAND: LexicalCommand<string> =
  createCommand("INSERT_TEXT_AT_CURSOR_COMMAND");

export function InsertTextAtCursorPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand<string>(
      INSERT_TEXT_AT_CURSOR_COMMAND,
      (text) => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) return false;

        const node = $createTextNode(text);
        selection.insertNodes([node]);
        return true;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  }, [editor]);

  return null;
}
